<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <div class="rightBtn">
          <template v-if="authority.isAdmin">
            <a
              class="linkText--text csvSampleStyle font-weight-bold"
              :href="csvSampleUrl"
              target="_blank"
            >
              {{ '※' + $t('common.common_csv-sample') }}
            </a>
            <label class="fileInputLabel">
              {{ $t('common.common_csv-import') }}
              <input
                ref="file"
                type="file"
                class="fileInput"
                @change="fileSelected"
              />
            </label>
          </template>
          <NormalButton
            :text="buttonName"
            height="32px"
            width="100px"
            class="text-right"
            @click="dialogInfo.register = true"
          />
          <MasterSupplierDialog
            v-model="dialogInfo.register"
            @success="registerSuccess()"
          />
        </div>
      </template>
      <template #search>
        <SupplierSearch :filter="filter" />
      </template>
      <template #list>
        <div class="supplierTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getFilterCustomerList"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.isEnabled`]="{ item }">
              {{ getSupplierStatus(item.isEnabled) }}
            </template>
            <template #[`item.name`]="{ item }">
              <div class="font-weight-bold">{{ item.name || '-' }}</div>
            </template>
            <template #[`item.abbreviation`]="{ item }">
              {{ item.abbreviation || '-' }}
            </template>
            <template #[`item.description`]="{ item }">
              {{ item.description || '-' }}
            </template>
            <template #[`item.addressInfo`]="{ item }">
              <div class="my-2">
                <div
                  v-if="
                    getPostalCode(item.postalCode, item.addressCountryId) ||
                    getRegionName(item.addressCountryId, item.regionId) ||
                    item.address1 ||
                    item.address2
                  "
                >
                  <v-row
                    v-if="getPostalCode(item.postalCode, item.addressCountryId)"
                    no-gutters
                  >
                    {{
                      '〒' +
                      getPostalCode(item.postalCode, item.addressCountryId)
                    }}
                  </v-row>
                  <v-row no-gutters>
                    {{
                      (getRegionName(item.addressCountryId, item.regionId) ||
                        '') + (item.address1 || '')
                    }}
                  </v-row>
                  <v-row no-gutters>{{ item.address2 }}</v-row>
                </div>
                <div v-else>{{ '-' }}</div>
              </div>
            </template>
            <template #[`item.contactInfo`]="{ item }">
              <div class="my-2">
                <div
                  v-if="
                    getPhoneNumber(
                      item.phoneNumber,
                      item.phoneNumberCountryId
                    ) ||
                    getPhoneNumber(item.faxNumber, item.faxNumberCountryId) ||
                    item.email
                  "
                >
                  <v-row
                    v-if="
                      getPhoneNumber(
                        item.phoneNumber,
                        item.phoneNumberCountryId
                      )
                    "
                    no-gutters
                  >
                    {{
                      'TEL:' +
                      getPhoneNumber(
                        item.phoneNumber,
                        item.phoneNumberCountryId
                      )
                    }}
                  </v-row>
                  <v-row
                    v-if="
                      getPhoneNumber(item.faxNumber, item.faxNumberCountryId)
                    "
                    no-gutters
                  >
                    {{
                      'FAX:' +
                      getPhoneNumber(item.faxNumber, item.faxNumberCountryId)
                    }}
                  </v-row>
                  <v-row v-if="item.email" no-gutters>
                    {{ 'Email:' + item.email }}
                  </v-row>
                </div>
                <div v-else>{{ '-' }}</div>
              </div>
            </template>
            <template #[`item.section`]="{ item }">
              <div>{{ item.section || '-' }}</div>
            </template>
            <template #[`item.rep`]="{ item }">
              <div>{{ item.rep || '-' }}</div>
            </template>
            <template #[`item.suggestedReceivingLocation`]="{ item }">
              {{
                getSuggestedReceivingLocation(
                  item.suggestedReceivingLocationId
                ) || '-'
              }}
            </template>
            <template #[`item.paymentCriteria`]="{ item }">
              <div>{{ item.paymentCriteria || '-' }}</div>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.edit`]="{ item }">
              <v-layout>
                <WhiteButton
                  text="common.common_edit"
                  height="32px"
                  width="48px"
                  class="mx-2"
                  @click="edit(item)"
                />
                <div v-if="item.isEnabled" class="mx-auto">
                  <NormalButton
                    :text="$t('表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    @click="editIsEnabledToFalse(item)"
                  />
                </div>
                <div v-else class="mx-auto">
                  <NormalButton
                    :text="$t('非表示')"
                    class="mr-2"
                    btnClass="pa-2"
                    height="32px"
                    color="white"
                    textColor="thinText--text"
                    @click="editIsEnabledToTrue(item)"
                  />
                </div>
              </v-layout>
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <MasterSupplierDialog
      v-model="dialogInfo.edit"
      :supplierData="supplierData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { commonUtil, countryUtil, countryCallingCodeUtil } from '@/util'
import headers from './headers'
import { Master } from '@/components/layouts'
import { NormalButton, WhiteButton } from '@/components/items'
import { MasterSupplierDialog } from '@/components/layouts/Dialogs'
import SupplierSearch from '@/components/layouts/ClientInfo/Supplier/SupplierSearch'

export default {
  components: {
    Master,
    MasterSupplierDialog,
    NormalButton,
    WhiteButton,
    SupplierSearch
  },
  data: () => {
    return {
      pageTitle: 'product.product_vendor-management',
      buttonName: 'product.product_supplier-registration',
      supplierData: {},
      headers: headers.headers,
      itemKey: 'supplierId',
      dialogInfo: {
        register: false,
        edit: false
      },
      editMode: false,
      suggestedReceivingLocations: [],
      uploadFile: '',
      filter: {
        supplierName: '',
        abbreviation: '',
        description: '',
        address: '',
        contact: '',
        section: '',
        rep: '',
        desiredWarehousingLocation: '',
        paymentCriteria: '',
        isEnabled: true
      }
    }
  },
  created() {
    this.init()
    this.getSuggestedReceivingLocationList()
  },
  computed: {
    ...mapGetters('User', ['authority']),
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    },
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/supplier_upload_sample_20220609.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/supplier_upload_sample_20220609.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/supplier_upload_sample_20220609.zip'
      }
      return url
    },
    getFilterCustomerList() {
      let supplierList = this.getSuppliersFromState()

      // 仕入先名
      const supplierName = this.filter.supplierName.replace(/\s+/g, '')
      if (supplierName !== '') {
        supplierList = supplierList.filter((supplier) => {
          return (
            supplier.name &&
            supplier.name.replace(/\s+/g, '').includes(supplierName)
          )
        })
      }

      // 仕入先呼称
      const abbreviation = this.filter.abbreviation.replace(/\s+/g, '')
      if (abbreviation !== '') {
        supplierList = supplierList.filter((supplier) => {
          return (
            supplier.abbreviation &&
            supplier.abbreviation.replace(/\s+/g, '').includes(abbreviation)
          )
        })
      }

      // 補助説明
      const description = this.filter.description.replace(/\s+/g, '')
      if (description !== '') {
        supplierList = supplierList.filter((supplier) => {
          return (
            supplier.description &&
            supplier.description.replace(/\s+/g, '').includes(description)
          )
        })
      }

      // 住所
      const address = this.filter.address.replace(/\s+/g, '')
      if (address !== '') {
        supplierList = supplierList.filter((supplier) => {
          const postcode = commonUtil.formatPostalCode(
            supplier.postalCode,
            supplier.addressCountryId
          )
          const displayPostcode = postcode ? '〒' + postcode : ''
          const regionName = countryUtil.getRegionInfo(
            supplier.addressCountryId,
            supplier.regionId
          ).label
          const address1 = (regionName || '') + (supplier.address1 || '')
          const displayAdress =
            displayPostcode + address1 + (supplier.address2 || '')
          return displayAdress.replace(/\s+/g, '').includes(address)
        })
      }

      // 連絡先
      const contact = this.filter.contact.replace(/\s+/g, '')
      if (contact !== '') {
        supplierList = supplierList.filter((supplier) => {
          const phoneNumber = countryCallingCodeUtil.formatPhoneNumber(
            supplier.phoneNumber,
            supplier.phoneNumberCountryId
          )
          const displayPhoneNumber = phoneNumber ? 'TEL:' + phoneNumber : ''
          const faxNumber = countryCallingCodeUtil.formatPhoneNumber(
            supplier.faxNumber,
            supplier.faxNumberCountryId
          )
          const displayFaxNumber = faxNumber ? 'FAX:' + faxNumber : ''
          const email = supplier.email ? 'Email:' + supplier.email : ''
          const displayContact = displayPhoneNumber + displayFaxNumber + email
          return displayContact.replace(/\s+/g, '').includes(contact)
        })
      }

      // 担当部署
      const section = this.filter.section.replace(/\s+/g, '')
      if (section !== '') {
        supplierList = supplierList.filter((supplier) => {
          return (
            supplier.section &&
            supplier.section.replace(/\s+/g, '').includes(section)
          )
        })
      }

      // 担当者
      const rep = this.filter.rep.replace(/\s+/g, '')
      if (rep !== '') {
        supplierList = supplierList.filter((supplier) => {
          return supplier.rep && supplier.rep.replace(/\s+/g, '').includes(rep)
        })
      }

      // 希望入庫場所
      const desiredWarehousingLocation = this.filter.desiredWarehousingLocation
      if (
        desiredWarehousingLocation !== '' &&
        desiredWarehousingLocation.value !== null
      ) {
        supplierList = supplierList.filter((supplier) => {
          return (
            supplier.suggestedReceivingLocationId ===
            desiredWarehousingLocation.value
          )
        })
      }

      // 支払条件
      const paymentCriteria = this.filter.paymentCriteria.replace(/\s+/g, '')
      if (paymentCriteria !== '') {
        supplierList = supplierList.filter((supplier) => {
          return (
            supplier.paymentCriteria &&
            supplier.paymentCriteria
              .replace(/\s+/g, '')
              .includes(paymentCriteria)
          )
        })
      }

      // 非表示フラグ
      const isEnabledFlg = this.filter.isEnabled
      if (isEnabledFlg) {
        supplierList = supplierList.filter((supplier) => {
          return supplier.isEnabled === 1
        })
      }

      return supplierList
    }
  },
  methods: {
    ...mapActions('Supplier', [
      'getSuppliersFromApi',
      'getSuggestedReceivingLocationListFromApi',
      'editSupplier',
      'fileUpload'
    ]),
    ...mapGetters('Supplier', [
      'getSuppliersFromState',
      'getSupplierMaxSortNumber',
      'getSuggestedReceivingLocationListFromState'
    ]),
    ...mapGetters('Common', [
      'getCountryCallingCodeJpFromState',
      'getCountryJpFromState'
    ]),

    setCountryCallingCode(countryId) {
      return this.editMode
        ? countryCallingCodeUtil.getPhoneNumberInfoById(countryId)
        : this.getCountryCallingCodeJpFromState()
    },
    setCountryId(countryId) {
      return this.editMode
        ? countryUtil.getCountryIdInfo(countryId)
        : this.getCountryJpFromState()
    },
    async init() {
      await this.getSuggestedReceivingLocationListFromApi()
      await this.getSuppliersFromApi()
    },
    async getSuggestedReceivingLocationList() {
      await this.getSuggestedReceivingLocationListFromApi()
      this.suggestedReceivingLocations =
        this.getSuggestedReceivingLocationListFromState()
    },
    getSuggestedReceivingLocation(suggestedReceivingLocationId) {
      const suggestedReceivingLocation = this.suggestedReceivingLocations.find(
        (element) =>
          element.suggestedReceivingLocationId === suggestedReceivingLocationId
      )
      if (suggestedReceivingLocation) {
        return suggestedReceivingLocation.location
      } else {
        return ''
      }
    },
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    },
    getPostalCode(postalCode, countryId) {
      return commonUtil.formatPostalCode(postalCode, countryId)
    },
    getPhoneNumber(phone, callingCode) {
      return countryCallingCodeUtil.formatPhoneNumber(phone, callingCode)
    },
    getSupplierStatus(isEnable) {
      const supplierStatus = isEnable
        ? this.$t('common.common_normal')
        : this.$t('common.common_hide')
      return supplierStatus
    },

    edit(supplier) {
      this.supplierData = { ...supplier }
      this.dialogInfo.edit = true
    },

    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async editIsEnabledToFalse(item) {
      this.editMode = true
      await this.editSupplier({
        supplierId: item.supplierId,
        params: this.initDataForEditSupplier(item, false)
      })
      item.isEnabled = 0
      this.editMode = false
    },
    async editIsEnabledToTrue(item) {
      this.editMode = true
      await this.editSupplier({
        supplierId: item.supplierId,
        params: this.initDataForEditSupplier(item, true)
      })
      item.isEnabled = 1
      this.editMode = false
    },
    initDataForEditSupplier(item, isEnabled) {
      const formatData = { ...item }
      formatData.isEnabled = isEnabled
      formatData.phone = {
        countryCode: this.setCountryCallingCode(
          item.phoneNumberCountryId
        ),
        phoneNumber: item.phoneNumber
      }
      formatData.fax = {
        countryCode: this.setCountryCallingCode(
          item.faxNumberCountryId
        ),
        phoneNumber: item.faxNumber
      }
      formatData.country = this.setCountryId(item.addressCountryId)
      formatData.region = countryUtil.getRegionInfo(
        item.addressCountryId,
        item.regionId
      )
      formatData.sortNumber = this.editMode
        ? item.sortNumber
        : this.getSupplierMaxSortNumber() + 1

      return formatData
    },
    async fileSelected(event) {
      this.uploadFile = event.target.files[0]

      const formData = new FormData()
      formData.append('uploadFile', this.uploadFile)
      const uploadData = await this.fileUpload(formData)
      if (uploadData) {
        const nameList = uploadData.data.registeredSupplierList.map((ele) => {
          return ele.name
        })
        const nameListStr = nameList.join(', ')
        alert(`${this.$t('common.common_register-result')}
${nameListStr}
        `)
        this.init()
      }

      this.$refs.file.value = '' // 初期化
    }
  }
}
</script>
<style scoped lang="scss">
.supplierTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
  ::v-deep .v-data-table td:last-child {
    padding: 0 8px !important;
  }
}
.rightBtn {
  display: flex;
  justify-content: flex-end;
}
.fileInput {
  display: none;
}
.fileInputLabel {
  width: 108px;
  height: 32px;
  margin: 0px 12px 0px 0px;
  padding: 7px 9px 11px 11px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
  font-size: 12px;
  color: #6a6a6a;
}
.csvSampleStyle {
  width: 88px;
  height: 12px;
  margin: 8px 12px 0px 0px;
  font-size: 12px;
  text-decoration: none;
}
</style>
